module.exports = __webpack_public_path__ + "images/category_lp/game_console/assessment_achievements/3@2x_5ff7b22cd40c62580afc51447de27f97.png";